"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useEnvironment = require("./useEnvironment");
Object.keys(_useEnvironment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useEnvironment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useEnvironment[key];
    }
  });
});
